import styled, { css } from 'styled-components/macro';
import { baseButtonStyles } from 'styles/components/Button';

const activeStyles = css`
  background-color: ${({ theme }) => theme.colors.white};
  color: ${({ theme }) => theme.colors.trust._60};
  fill: ${({ theme }) => theme.colors.trust._60};
`;

export const $NewMenuItemBadge = styled.span`
  position: absolute;
  top: -8px;
  right: 8px;
  background-color: #0080ff;
  color: white;
  font-size: 10px;
  padding: 2.5px 6px;
  border-radius: 4px;
  font-weight: 500;
`;
const $MenuLink = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  margin: 12px 0;
  padding: 8px;
  font-size: ${({ theme }) => theme.font.size.body.sm};
  color: ${({ theme }) => theme.colors.neutral._90};
  fill: ${({ theme }) => theme.colors.neutral._90};
  background-color: ${({ $isHighlighted, theme }) =>
    $isHighlighted ? theme.colors.neutral._20 : 'transparent'};
  border: ${({ $isHighlighted }) =>
    $isHighlighted ? '1px solid #DADAE2' : 'none'};
  border-radius: 6px !important;
  transition: background-color 150ms ease;

  ${baseButtonStyles}

  .title-row {
    display: flex;
    align-items: center;
    width: 100%;
  }

  .icon {
    margin-right: 9px;
    display: flex;
    justify-content: center;
  }

  .label {
    line-height: 1;
  }

  .description {
    color: ${({ theme }) => theme.colors.neutral._70};
    font-size: 12px;
    line-height: 1.5;
    margin-top: 8px;
  }

  &:hover {
    background-color: ${({ theme }) => theme.colors.white};
    color: ${({ theme }) => theme.colors.neutral._100};
    fill: ${({ theme }) => theme.colors.neutral._100};
    ${props => props.$isActive && activeStyles}
  }

  ${props => props.$isActive && activeStyles}
`;

export const $NavActiveDot = styled.span`
  width: 8px;
  height: 8px;
  background-color: #ff4d4d;
  border-radius: 50%;
  display: inline-block;
  margin-left: 12px;
`;

export default $MenuLink;
